<button
  mat-button
  class="tool-btn"
  [matTooltip]="'TOOLBAR.ALIGN_OPTS' | translate"
  matTooltipShowDelay="400"
  matTooltipHideDelay="400"
  [matMenuTriggerFor]="alignMenu"
  [disabled]="!canDoGroupActions">
  <mat-icon svgIcon="align"></mat-icon>
</button>
<mat-menu #alignMenu="matMenu" class="align-menu">
  <ng-container *ngFor="let action of alignActions">
    <button mat-menu-item (click)="alignAction(action)">
      <mat-icon svgIcon="{{ action.svg }}"></mat-icon>
      <span>{{ 'TOOLBAR.' + action.text | translate }}</span>
    </button>
    <div class="divider" *ngIf="action.svg === 'align-hor'"></div>
  </ng-container>
</mat-menu>
<button
  mat-button
  class="tool-btn"
  [matTooltip]="'TOOLBAR.ARRANGE_OPTS' | translate"
  matTooltipShowDelay="400"
  matTooltipHideDelay="400"
  [matMenuTriggerFor]="sizingMenu"
  [disabled]="!canDoGroupActions">
  <mat-icon svgIcon="sizing"></mat-icon>
</button>
<mat-menu #sizingMenu="matMenu" class="sizing-menu">
  <button mat-menu-item *ngFor="let action of sizingActions" (click)="resizeCells(action.param)">
    <mat-icon svgIcon="{{ action.svg }}"></mat-icon>
    <span>{{ 'TOOLBAR.' + action.text | translate }}</span>
  </button>
</mat-menu>
